<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    opacity="0.2"
    x="1"
    y="4"
    width="18"
    height="12"
    rx="2"
    fill="currentColor"
  />
  <path d="M5 6H3V8H5V6Z" fill="currentColor" />
  <path d="M12 11V9H10V11H12Z" fill="currentColor" />
  <path d="M5 12H3V14H5V12Z" fill="currentColor" />
  <path d="M14 14V12H6V14H14Z" fill="currentColor" />
  <path d="M15 12H17V14H15V12Z" fill="currentColor" />
  <path d="M9 9V11H7V9H9Z" fill="currentColor" />
  <path d="M6 6H8V8H6V6Z" fill="currentColor" />
  <path d="M11 6H9V8H11V6Z" fill="currentColor" />
  <path d="M12 6H14V8H12V6Z" fill="currentColor" />
  <path d="M17 6H15V8H17V6Z" fill="currentColor" />
  <path d="M3 9H6V11H3V9Z" fill="currentColor" />
  <path d="M17 9H13V11H17V9Z" fill="currentColor" />
</svg>
